import Category from "./Category";
export default class MediaGrid {
    files?: Category[] = [];
}
